module.exports = __webpack_public_path__ + "img/icon_university.efd4db2a.png";